import React, { useEffect, useState,useCallback } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import {
  getBoruProfilUretimDetail,
  updateBoruProfilUretim,
} from "../../../api/uretim/boruProfilDaily";
import "bootstrap/dist/css/bootstrap.min.css";
import { useAuth } from "../../context/AuthContext";

export default function OperatorPageV3() {
  const { token } = useAuth();
  const user = token ? jwtDecode(token) : null;

  const { id } = useParams();
  const navigate = useNavigate();

  const [saat, setSaat] = useState("");
  const [loading, setLoading] = useState(true);
  const [form, setForm] = useState({});
  const [mesaj, setMesaj] = useState("");
  const [openNote, setOpenNote] = useState({});

  // SAAT
  useEffect(() => {
    const t = setInterval(() => {
      setSaat(new Date().toLocaleTimeString("tr-TR"));
    }, 1000);
    return () => clearInterval(t);
  }, []);

  // FORM GETİR
  const loadForm = useCallback(async () => {
    if (!id) return;

    try {
      setLoading(true);
      const res = await getBoruProfilUretimDetail(id);
      setForm(res.data);
    } catch (err) {
      console.log(err);
      alert("Form yüklenemedi!");
    } finally {
      setLoading(false);
    }
  }, [id]);

  useEffect(() => {
    loadForm();
  }, [loadForm]);

  // INPUT update
  const updateField = (key, value) => {
    setForm((prev) => ({ ...prev, [key]: value }));
  };

  const updateAltField = (key, value) => {
    setForm((prev) => ({
      ...prev,
      alternatif: { ...prev.alternatif, [key]: value },
    }));
  };

  const addDurus = (key, dk) => {
    const dakika = Number(dk);
    if (!dakika) return;

    setForm((prev) => ({
      ...prev,
      duruslar: {
        ...prev.duruslar,
        [key]: (prev.duruslar?.[key] || 0) + dakika,
      },
    }));
  };
  useEffect(() => {
    if (!form?.duruslar) return;

    const initial = {};
    Object.keys(form.duruslar).forEach((k) => {
      if (k.endsWith("Note") && form.duruslar[k]) {
        const baseKey = k.replace("Note", "");
        initial[baseKey] = true; // not varsa otomatik aç
      }
    });

    setOpenNote(initial);
  }, [form]);

  // Kaydet
  const kaydet = async () => {
    try {
      await updateBoruProfilUretim({
        documentId: id,
        adminId: user._id, // giriş yapan admin bilgisi
        adminName: user.name, // admin adı
        updates: form, // düzeltilmiş form
      });

      alert("Kaydedildi!");
    } catch (err) {
      console.log(err);
      alert("Kaydedilemedi!");
    }
  };

  if (loading) {
    return (
      <div className="vh-100 d-flex justify-content-center align-items-center">
        <div className="spinner-border text-primary" />
      </div>
    );
  }

  const DURUS_LISTESI = [
    { label: "AKÜMÜLASYON", key: "akumulasyon" },
    { label: "YIĞMA", key: "yig" },
    { label: "FORM", key: "form" },
    { label: "KAYNAK", key: "kaynak" },
    { label: "ELEKTRİK KESİNTİSİ", key: "elektrikKesintisi" },
    { label: "ELEKTRİK ARIZASI", key: "elektrikArizasi" },
    { label: "GALVANİZ ÜNİTESİ", key: "galvanizUnitesi" },
    { label: "KALİBRE + TÜRK KAFALARI", key: "kalibreTurkKafalari" },
    { label: "YAĞLAMA", key: "yaglama" },
    { label: "RULMAN DEĞİŞİMİ", key: "rulmanDegisimi" },
    { label: "TESTERE ARIZASI", key: "testereArizasi" },
    { label: "TESTERE DEĞİŞİMİ", key: "testereDegisimi" },
    { label: "MAKARA DEĞİŞİMİ", key: "makaraDegisimi" },
    { label: "EBAT AYARI", key: "ebatAyari" },
    { label: "İSTİF", key: "istif" },
    { label: "İŞ EMRİ YOK", key: "isEmriYok" },
    { label: "PERSONEL EKSİKLİĞİ", key: "personelEksikligi" },
    { label: "YÜKLEME YAPILMASI", key: "yuklemeYapilmasi" },
    { label: "KALIP DEĞİŞİMİ", key: "kalipDegisimi" },
    { label: "TOPLANTI - EĞİTİM", key: "toplantiEgitim" },
    { label: "SERVİS GEÇ GELMESİ", key: "servisGecGelmesi" },
    { label: "VİNÇ BEKLEME", key: "vincBekleme" },
    { label: "DİĞER SEBEPLER", key: "digerSebepler" },
    { label: "YEMEK - ÇAY MOLASI", key: "yemekCayMolasi" },
  ];

  const MALZEME_NUMBER_FIELDS = [
    "kalinlik",
    "en1",
    "en2",
    "boy",
    "bantEni",
    "bagIci",
  ];
  const mesajKaydet = async () => {
    if (!mesaj.trim()) return;

    try {
      await updateBoruProfilUretim.post({ text: mesaj });
      setMesaj("");

      // Mesaj gönderildi → formu yeniden çek (messages güncel gelsin)
      await loadForm();

      // Modal aç
      const modalEl = document.getElementById("mesajModal");
      const modal = new window.bootstrap.Modal(modalEl);
      modal.show();
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <div
      className="mobile-wrapper"
      style={{ background: "#f2f2f2", padding: 15 }}
    >
      <style>{`
      @media (max-width: 768px) {

        .mobile-wrapper {
          padding: 8px !important;
        }

        .mobile-header {
          padding: 6px !important;
        }

        .mobile-header button {
          font-size: 0.8rem !important;
          padding: 4px 8px !important;
        }

        .mobile-top-info h3,
        .mobile-top-info h4 {
          font-size: 1rem !important;
        }

        .form-grid {
          grid-template-columns: 1fr !important;
          gap: 10px !important;
        }

        .form-grid input,
        .form-grid label {
          font-size: 0.9rem !important;
        }

        .durus-item {
          flex-direction: column !important;
          align-items: flex-start !important;
          gap: 8px !important;
          padding: 10px !important;
        }

        .durus-item label {
          font-size: 1rem !important;
          width: 100% !important;
        }

        .durus-item input {
          width: 100% !important;
          font-size: 0.9rem !important;
        }

        .durus-item button {
          width: 100% !important;
          font-size: 0.8rem !important;
        }

        .durus-item div {
          font-size: 1rem !important;
          width: 100% !important;
          text-align: left !important;
        }

        .general-durus {
          font-size: 1.3rem !important;
          padding: 8px !important;
        }

        .message-input {
          flex-direction: column !important;
          gap: 10px !important;
        }

        .message-input input {
          width: 100% !important;
          font-size: 1rem !important;
        }

        .message-input button {
          width: 100% !important;
          font-size: 1rem !important;
        }
      }
    `}</style>

      {/* HEADER */}
      <div
        className="mobile-header d-flex justify-content-between align-items-center mb-2 px-1"
        style={{
          position: "sticky",
          top: 0,
          background: "#f2f2f2",
          padding: 10,
          zIndex: 999,
          borderBottom: "1px solid #ddd",
        }}
      >
        <button
          className="btn btn-secondary btn-sm"
          onClick={() => navigate("/BoruProfilAnlik")}
        >
          Geri
        </button>

        <button className="btn btn-success" onClick={kaydet}>
          Kaydet
        </button>
      </div>

      {/* ÜST BİLGİ */}
      <div className="mobile-top-info d-flex justify-content-between align-items-center mb-3 px-1">
        <h3 className="fw-bold m-0">{saat}</h3>
        <h3 className="fw-bold m-0">Makina - {form.makinaAdi}</h3>
        <h4 className="fw-bold m-0">{form.operator}</h4>
      </div>

      {/* FORM BLOĞU */}
      <div className="bg-white shadow-sm rounded p-3">
        <h5 className="fw-bold mb-3">İş Emri Bilgileri</h5>

        <div
          className="form-grid mb-3"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4,1fr)",
            gap: 16,
          }}
        >
          <div>
            <label className="form-label">Firma</label>
            <input
              className="form-control"
              value={form.firma || ""}
              onChange={(e) => updateField("firma", e.target.value)}
            />
          </div>

          <div>
            <label className="form-label">Form No</label>
            <input
              type="number"
              className="form-control"
              value={form.formNo ?? ""}
              onChange={(e) =>
                updateField(
                  "formNo",
                  e.target.value === "" ? null : Number(e.target.value)
                )
              }
            />
          </div>

          <div>
            <label className="form-label">İş Emri No</label>
            <input
              type="number"
              className="form-control"
              value={form.isEmriNo ?? ""}
              onChange={(e) =>
                updateField(
                  "isEmriNo",
                  e.target.value === "" ? null : Number(e.target.value)
                )
              }
            />
          </div>
        </div>

        {/* MALZEME */}
        <h5 className="fw-bold mt-4 mb-3">Malzeme / Üretim</h5>
        <div
          className="form-grid mb-3"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4,1fr)",
            gap: 16,
          }}
        >
          {[
            "malzemeCinsi",
            "kalinlik",
            "en1",
            "en2",
            "boy",
            "bantEni",
            "bagIci",
          ].map((key) => {
            const isNumber = MALZEME_NUMBER_FIELDS.includes(key);
            return (
              <div key={key}>
                <label className="form-label">{key.toUpperCase()}</label>
                <input
                  className="form-control"
                  type={isNumber ? "number" : "text"}
                  value={form[key] ?? ""}
                  onChange={(e) =>
                    isNumber
                      ? updateField(
                          key,
                          e.target.value === "" ? null : Number(e.target.value)
                        )
                      : updateField(key, e.target.value)
                  }
                />
              </div>
            );
          })}
        </div>

        {/* HIZ */}
        <h5 className="fw-bold mt-4 mb-3">Hız Bilgileri</h5>
        <div
          className="form-grid mb-3"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4,1fr)",
            gap: 16,
          }}
        >
          {[
            { key: "hedefHiz", label: "Hedef Hız" },
            { key: "gerceklesenHiz", label: "Gerçekleşen Hız" },
            { key: "fiiliCalismaSuresi", label: "Fiilî Çalışma Süresi" },
            { key: "toplamSure", label: "Toplam (Duruş + Fiili)" },
          ].map((item) => (
            <div key={item.key}>
              <label className="form-label">{item.label}</label>

              {item.key === "toplamSure" ? (
                <input
                  type="number"
                  className="form-control"
                  value={(() => {
                    const durusToplam = Object.entries(form.duruslar || {})
                      .filter(([k]) => !k.includes("Note"))
                      .reduce((t, [_, v]) => t + Number(v || 0), 0);

                    const fiili = Number(form.fiiliCalismaSuresi || 0);

                    return durusToplam + fiili;
                  })()}
                  readOnly
                />
              ) : (
                <input
                  type="number"
                  className="form-control"
                  value={form[item.key] ?? ""}
                  onChange={(e) =>
                    updateField(
                      item.key,
                      e.target.value === "" ? null : Number(e.target.value)
                    )
                  }
                />
              )}
            </div>
          ))}
        </div>

        {/* TESTERE */}
        <div className="mb-3">
          <div className="form-check">
            <input
              id="testereKirilmasi"
              className="form-check-input"
              type="checkbox"
              checked={!!form.testereKirilmasi}
              onChange={(e) =>
                updateField("testereKirilmasi", e.target.checked)
              }
            />
            <label className="form-check-label" htmlFor="testereKirilmasi">
              Testere Kırılması
            </label>
          </div>
        </div>

        {/* MAMÜL */}
        <h5 className="fw-bold mt-4 mb-3">Mamül Üretim</h5>
        <div
          className="form-grid mb-3"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4,1fr)",
            gap: 16,
          }}
        >
          {["bagAdeti", "yarimBag", "mamulMiktariKg", "iskartaKg"].map(
            (key) => (
              <div key={key}>
                <label className="form-label">{key.toUpperCase()}</label>
                <input
                  type="number"
                  className="form-control"
                  value={form[key] ?? ""}
                  onChange={(e) =>
                    updateField(
                      key,
                      e.target.value === "" ? null : Number(e.target.value)
                    )
                  }
                />
              </div>
            )
          )}
        </div>

        {/* ALTERNATİF */}
        <h5 className="fw-bold mt-4 mb-3">Alternatif Üretim</h5>
        <div
          className="form-grid mb-3"
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(4,1fr)",
            gap: 16,
          }}
        >
          {["bagAdeti", "yarimBag", "miktarKg"].map((key) => (
            <div key={key}>
              <label className="form-label">{key.toUpperCase()}</label>
              <input
                type="number"
                className="form-control"
                value={form.alternatif?.[key] ?? ""}
                onChange={(e) =>
                  updateAltField(
                    key,
                    e.target.value === "" ? 0 : Number(e.target.value)
                  )
                }
              />
            </div>
          ))}
        </div>
      </div>

      {/* DURUŞ PANELİ */}
      <div className="mt-3 mb-4">
        <div className="row">
          {[0, 1].map((col) => (
            <div className="col-12 col-md-6" key={col}>
              {DURUS_LISTESI.slice(
                col === 0 ? 0 : Math.ceil(DURUS_LISTESI.length / 2),
                col === 0
                  ? Math.ceil(DURUS_LISTESI.length / 2)
                  : DURUS_LISTESI.length
              ).map((item) => {
                const key = item.key;
                const minuteValue = form.duruslar?.[key] || 0;

                const noteKey = key + "Note";
                const noteValue = form.duruslar?.[noteKey] || "";

                return (
                  <div
                    key={key}
                    className="durus-item bg-white rounded border p-3 mb-2"
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 10,
                    }}
                  >
                    {/* === SATIR 1 === */}
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        width: "100%",
                      }}
                    >
                      {/* LABEL — SOLDA */}
                      <div
                        style={{
                          flex: 1,
                          fontWeight: 800,
                          fontSize: 18,
                          minWidth: 150,
                          maxWidth: 200,
                        }}
                      >
                        {item.label}
                      </div>

                      {/* === SAĞ GRUP: DK INPUT → KAYDET → NOT EKLE → DK === */}
                      <div
                        style={{
                          flex: 1,
                          display: "flex",
                          justifyContent: "flex-end",
                          alignItems: "center",
                          gap: 8,
                          flexShrink: 0,
                        }}
                      >
                        {/* DK INPUT */}
                        <input
                          type="number"
                          id={`inp_${key}_${col}`}
                          placeholder="dk"
                          className="form-control"
                          style={{
                            width: 70,
                            textAlign: "center",
                            flexShrink: 0,
                          }}
                        />

                        {/* KAYDET */}
                        <button
                          className="btn btn-primary btn-sm"
                          onClick={() => {
                            const el = document.getElementById(
                              `inp_${key}_${col}`
                            );
                            const v = el.value;
                            addDurus(key, v);
                            el.value = "";
                          }}
                        >
                          Kaydet
                        </button>

                        {/* NOT EKLE */}
                        <button
                          className="btn btn-outline-secondary btn-sm"
                          onClick={() =>
                            setOpenNote((p) => ({ ...p, [key]: !p[key] }))
                          }
                          style={{ whiteSpace: "nowrap" }}
                        >
                          {openNote[key] ? "Notu Kapat" : "Not Ekle"}
                        </button>

                        {/* DK DEĞERİ — EN SAĞ */}
                        <div
                          style={{
                            marginLeft: 10,
                            fontSize: 18,
                            fontWeight: 700,
                            whiteSpace: "nowrap",
                            minWidth: 60,
                            textAlign: "left",
                          }}
                        >
                          {minuteValue} dk
                        </div>
                      </div>
                    </div>

                    {/* === SATIR 2: NOT === */}
                    {openNote[key] && (
                      <input
                        className="form-control"
                        placeholder="Not / Açıklama..."
                        value={noteValue}
                        onChange={(e) => {
                          const v = e.target.value;
                          setForm((prev) => ({
                            ...prev,
                            duruslar: {
                              ...prev.duruslar,
                              [noteKey]: v,
                            },
                          }));
                        }}
                        style={{ fontSize: 15 }}
                      />
                    )}
                  </div>
                );
              })}
            </div>
          ))}
        </div>
      </div>

      {/* GENEL DURUŞ */}
      <div
        className="general-durus bg-white rounded border fw-bold text-center"
        style={{
          fontSize: 22,
          padding: "10px 0",
          marginTop: 10,
          marginBottom: 10,
        }}
      >
        GENEL DURUŞ:{" "}
        {Object.entries(form.duruslar || {})
          .filter(([k, v]) => !k.includes("Note")) // not alanlarını çıkar
          .reduce((t, [k, v]) => t + Number(v || 0), 0)}{" "}
        dk
      </div>

      {/* MESAJ */}
      <div className="bg-white p-2 rounded border mt-4">
        <label className="fw-bold mb-1">Mesaj / Not</label>
        <div className="d-flex gap-2 message-input">
          <input
            type="text"
            className="form-control"
            placeholder="Not yazın..."
            value={mesaj}
            onChange={(e) => setMesaj(e.target.value)}
          />
          <button className="btn btn-primary" onClick={mesajKaydet}>
            Kaydet
          </button>
        </div>

        {form.messages && form.messages.length > 0 && (
          <div className="bg-white p-2 rounded border mt-3">
            <h6 className="fw-bold mb-2">Gönderilen Mesajlar</h6>

            <div style={{ maxHeight: 250, overflowY: "auto" }}>
              {[...form.messages]
                .sort((a, b) => new Date(b.date) - new Date(a.date))
                .map((m) => (
                  <div
                    key={m._id || m.date}
                    className="p-2 mb-2 rounded"
                    style={{ background: "#f7f7f7", border: "1px solid #ddd" }}
                  >
                    <div className="fw-bold">{m.user}</div>
                    <div>{m.text}</div>
                    <div style={{ fontSize: 12, color: "#999" }}>
                      {new Date(m.date).toLocaleString("tr-TR")}
                    </div>
                  </div>
                ))}
            </div>
          </div>
        )}
      </div>

      {/* MODAL */}
      <div
        className="modal fade"
        id="mesajModal"
        tabIndex="-1"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title">Mesaj Kaydedildi</h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
              ></button>
            </div>
            <div className="modal-body">Mesaj başarıyla kaydedildi.</div>
            <div className="modal-footer">
              <button className="btn btn-primary" data-bs-dismiss="modal">
                Tamam
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
